// import React, { useState } from 'react';
import { useState } from 'react';
import Calendar from 'react-calendar';
import '../../assets/styles/react-calendar.css'


const HolidayCalendar = ({ onDateClick }) => {
  const [value, onChange] = useState(new Date());
  // Dummy list of holidays
  // const holidays = [
  //   { date: '2024-01-01', title: 'New Year' },
 
  // ];

  // const handleClick = (date) => {
  //   const holiday = holidays.find((holiday) => holiday.date === date);
  //   if (holiday) {
  //     onDateClick(holiday.title);
  //   }
  // };



  return (
    <div>
    <Calendar onChange={onChange} value={value} />
  </div>
  );
};

export default HolidayCalendar;
